import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FIREWORK_COLORS = ['#2563eb', '#f59e0b', '#22c55e', '#ec4899', '#8b5cf6'];

const BURSTS = [
  { left: '16%', top: '16%', delay: '0ms' },
  { left: '82%', top: '12%', delay: '400ms' },
  { left: '50%', top: '8%', delay: '800ms' },
  { left: '28%', top: '38%', delay: '1200ms' },
  { left: '72%', top: '36%', delay: '1600ms' },
  { left: '48%', top: '52%', delay: '2000ms' },
];

const FireworkBurst = ({ left, top, delay }) => (
  <div className="demo-firework-burst" style={{ left, top, '--burst-delay': delay }}>
    {Array.from({ length: 12 }, (_, index) => (
      <span
        key={index}
        className="demo-firework-particle"
        style={{
          '--angle': `${index * 30}deg`,
          '--color': FIREWORK_COLORS[index % FIREWORK_COLORS.length],
        }}
      />
    ))}
  </div>
);

const DemoComplete = ({
  onStartTrial,
  onChoosePlan,
  startingTrial = false,
  choosingPlan = false,
  error = '',
}) => {
  const { t } = useTranslation();
  const busy = startingTrial || choosingPlan;

  return (
    <div className="relative mx-auto w-full max-w-2xl rounded-lg border border-border bg-card px-8 md:px-12 py-14 md:py-16 text-center shadow-elevation-sm">
      <div className="demo-firework-layer" aria-hidden="true">
        {BURSTS.map((burst) => (
          <FireworkBurst key={`${burst.left}-${burst.top}`} {...burst} />
        ))}
      </div>

      <div className="relative demo-complete-card">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
          <Icon name="PartyPopper" size={32} className="text-primary" />
        </div>
        <h3 className="text-2xl md:text-3xl font-semibold text-foreground mb-3">
          {t('demo.complete.heading')}
        </h3>
        <p className="text-sm md:text-base text-muted-foreground leading-relaxed max-w-md mx-auto mb-8">
          {t('demo.complete.body')}
        </p>
        {error && (
          <p className="text-sm text-destructive mb-4">{error}</p>
        )}
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
          <Button
            type="button"
            onClick={onStartTrial}
            loading={startingTrial}
            disabled={busy}
          >
            {t('demo.complete.trial')}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onChoosePlan}
            loading={choosingPlan}
            disabled={busy}
          >
            {t('demo.complete.choosePlan')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DemoComplete;
